import React from 'react';
import { Box, Typography } from '@mui/material';
import { complementaryInfoMailToClientIcon, lockIcon } from '@europrocurement/l2d-icons';
import { FlexyButton } from '@europrocurement/flexy-components';

export type InvoiceProvisionPaymentProps = {
    amount: number;
    isFacture?: boolean;
    onClickDemandeReglement?: () => void;
    onClickPaiement?: () => void;
};

const InvoiceProvisionPayment: React.FunctionComponent<InvoiceProvisionPaymentProps> = function ({
    amount,
    onClickDemandeReglement,
    onClickPaiement,
    isFacture = false,
}) {
    const wrapperInvoiceProvisionPaymentSx = {
        display: 'flex',
        alignItems: 'center',
        gap: '16px',
    };

    const labelSx = {
        fontSize: '15px',
        fontWeight: '600',
        lineHeight: '21px',
    };

    const amountLabelSx = {
        fontSize: '22px',
        fontWeight: '600',
        lineHeight: '26.4px',
    };

    const wrapperSx = {
        display: 'flex',
        alignItems: 'center',
        gap: '16px',
        justifyContent: 'space-between',
        marginTop: '16px',
    };

    return (
        <Box sx={wrapperSx}>
            <Box
                sx={wrapperInvoiceProvisionPaymentSx}
                data-testid="invoice-payment"
            >
                <Typography sx={labelSx}>
                    {isFacture ? 'Montant (TTC) à payer' : 'Provision (TTC) à payer'}
                </Typography>

                <Typography sx={amountLabelSx}>
                    {(Math.floor(amount * 100) / 100).toFixed(2)}&euro;
                </Typography>
            </Box>
            <Box sx={wrapperInvoiceProvisionPaymentSx}>
                {onClickDemandeReglement && amount > 0 ? (
                    <FlexyButton
                        label={isFacture ? 'Demander le règlement' : 'Demander la provision'}
                        icon={complementaryInfoMailToClientIcon}
                        variant="outlined"
                        color="primary"
                        onClick={() => onClickDemandeReglement()}
                    />
                ) : null}
                {onClickPaiement && amount > 0 ? (
                    <FlexyButton
                        label={isFacture ? 'Procéder au paiement' : 'Régler la provision'}
                        icon={lockIcon}
                        variant="contained"
                        onClick={() => onClickPaiement()}
                    />
                ) : null}
            </Box>
        </Box>
    );
};

export default InvoiceProvisionPayment;
